import { ActionType, ProColumns } from '@ant-design/pro-components';
import { DatePicker, Form, Input } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
// icons
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import { CheckStatus, CloseStatus, Filter, Plus } from 'base/ui/components/Icons';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { useTranslation } from 'react-i18next';
import { DATE_FORMAT_POST, PAGE_SIZE_DEFAULT, SYSTEM_TITLE } from 'utils/constants';
import { SearchModel } from 'pages/model';
import { commonPresenter, commonStore, customerSegmentPresenter, customerSegmentStore } from 'stores/root_store';
import { Link, useNavigate } from 'react-router-dom';
import { ROUTES } from 'base/routes/routes';
import { cloneDeep } from 'lodash';
import { CustomerSegmentModel } from 'services/Main/customerSegment_services';
import { formatNumber } from 'utils/formatHelper';
import { checkPermission, useCheckPermission } from 'utils/permissionHelper';
import { dropdownstatus } from 'pages/Components/dataDropDown';
import { CommonModel } from 'services/Main/common_services';
import usePartialState from 'hooks/usePartialState';
import dayjs from 'dayjs';
import useDebounce from 'hooks/useDebounce';
import * as Icon from 'base/ui/components/Icons';
import { getPlantCode } from 'utils/localStorageHelper';

const { RangePicker } = DatePicker;

const createCustomerSegmentation = () => {
  return observer(() => {
    useCheckPermission('INDEX');
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.customer-seg') + ' - ' + SYSTEM_TITLE;
    const navigate = useNavigate();
    const [open, setOpen] = useState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });
    const [form] = Form.useForm();

    // ==================================== STATE ===================================================
    // -------------------------------------- DANH SÁCH COMMON --------------------------------------

    //----------------------------------------- DATA TABLE ------------------------------------------
    const [dataPaging, setDataPaging] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: undefined,
        orderByDesc: undefined,
      },
      customerSegmentationCode: undefined,
      customerSegmentationName: undefined,
      active: true,
      company: getPlantCode()
    });
    // data table báo cáo
    const [dataTable, setDataTable] = useState<CustomerSegmentModel[]>([]);
    // ======================================================== function =================================================================
    // ----CÁC HÀM LẤY DATA -------------------------------------------------------------------

    const getDataTable = async (dataSearch: any) => {
      await customerSegmentPresenter.getlistCustomerSegments(customerSegmentStore, dataSearch);
      if (customerSegmentStore.listCustomerSegment.isSuccess) {
        const dataTemp = cloneDeep(customerSegmentStore.listCustomerSegment.data);
        setDataTable(dataTemp);
        return dataTemp;
      }
      setDataTable([]);
      return [];
    };

    // ---------------XỬ LÝ COLUMN VÀ TABLE-----------------------------------------------------------------------------------------------------
    const columns: ProColumns<CustomerSegmentModel>[] = [
      {
        title: t('zalo-notification.stt'),
        dataIndex: 'stt',
        key: 'stt',
        fixed: 'left',
        width: 30,
        onCell: (_, index) => ({
          className: 'text-center',
        }),
        align: 'center',
      },
      // Mã phân khúc
      {
        title: t('segment.ma-pk'),
        dataIndex: 'customerSegmentCode',
        key: 'customerSegmentCode',
        fixed: 'left',
        width: 100,

        onCell: (_, index) => ({
          className: 'text-center',
        }),
        render: (text, record) => (
          <Link
            to={ROUTES.CUSTOMER.CUSTOMER_SEGMENTATION.DETAIL.LINK + `?tabId=${record.id}DETAIL&tabName=${text}`}
          >
            {text}
          </Link>
        ),
      },
      // Tên phân khúc
      {
        title: t('segment.ten-pk'),
        dataIndex: 'customerSegmentName',
        key: 'customerSegmentName',
        fixed: 'left',
        width: 150,
        render: (text, record) => (
          <Link
            to={
              ROUTES.CUSTOMER.CUSTOMER_SEGMENTATION.DETAIL.LINK +
              `?tabId=${record.id}DETAIL&tabName=${record.customerSegmentName}`
            }
          >
            {text}
          </Link>
        ),
      },
      // Số lượng khách hàng
      {
        title: t('segment.sl-kh'),
        dataIndex: 'customerNumber',
        key: 'customerNumber',
        width: 100,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Trạng thái
      {
        title: t('segment.trang-thai'),
        dataIndex: 'actived',
        key: 'actived',
        width: 70,

        render: (_, record) =>
          record.actived ? (
            <CheckStatus width="14" className="!fill-[#0052cc] block mx-auto" />
          ) : (
            <CloseStatus width="14" className="!fill-red-500 block mx-auto" />
          ),
      },
      // công ty
      {
        title: t('search-form.company'),
        dataIndex: 'companyCode',
        key: 'companyCode',
        width: 100,
      },
      // Người tạo
      {
        title: t('segment.nguoi-tao'),
        dataIndex: 'createBy',
        key: 'createBy',
        width: 100,
      },
      //   Ngày tạo
      {
        title: t('segment.ngay-tao'),
        dataIndex: 'createTime',
        key: 'createTime',
        valueType: 'dateTime',
        fieldProps: {
          format: 'DD/MM/YYYY HH:mm:ss',
        },
        width: 100,
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      //   Chức năng
      // {
      //   title: t('Chức năng'),
      //   dataIndex: 'chucNang',
      //   key: 'chucNang',
      //   width: 150,
      //   render: (_, record) => (
      //     <div className="flex">
      //       <ButtonEdit />
      //     </div>
      //   ),
      // },
    ];

    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };
    // ============================================ XỬ LÝ TABS =========================================

    // ============================================LƯU MẪU BÁO CÁO =============================================
    const tableRef = useRef<ActionType>();

    // ============================================================ STATE ==========================================================
    const [reportState, setReportState] = usePartialState({
      loading: false,
    });

    // =========================================================================================================
    // ================================ LẤY DROPDOWN ===========================================================
    // công ty
    const [listSaleOrg, setListSaleOrg] = useState<CommonModel[]>([]);
    const [listCreateBy, setListCreateBy] = useState<CommonModel[]>([]);
    // data common date
    const [listCommonDate, setListCommonDate] = useState<CommonModel[]>([]);
    // disable rangePicker khi chọn ngày từ common
    const [disableRangePicker, setDisableRangePicker] = useState(false);
    const [loading, setLoading] = usePartialState({
      loadingSearch: false
    })


    const getListSaleOrg = async () => {
      await commonPresenter.getListSaleOrg(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListSaleOrg(commonStore.commonRespone.data);
      }
    };

    // Lấy danh sách common date
    const getListCommonDate = async () => {
      setLoading({ loadingSearch: true })
      await commonPresenter.getListSelectCommonDate(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCommonDate(commonStore.commonRespone.data);
      }
      setLoading({ loadingSearch: false })
    };

    // Lấy  danh sách người tạo
    const getListCreateBy = async (key = '') => {
      await commonPresenter.getListCreateBy(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        setListCreateBy(commonStore.commonRespone.data);
      }
    };
    const searchCreateBy = useDebounce(getListCreateBy, 500);

    // Lấy ngày bằng common data
    const getDateByKey = async (key: string) => {
      setLoading({ loadingSearch: true })
      await commonPresenter.getDateByCommonDate(commonStore, key);
      if (commonStore.commonDate.fromDate) {
        form.setFieldValue("ngayTao", [
          dayjs(commonStore.commonDate.fromDate),
          dayjs(commonStore.commonDate.toDate),
        ]);
      } else {
        form.setFieldValue("ngayTao", undefined);
      }
      setLoading({ loadingSearch: false })
    };

    useEffect(() => {
      getListSaleOrg();
      getListCommonDate();
      getListCreateBy();
    }, []);

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.customer-seg'),
          },
        ]}
        extras={
          <>
            {checkPermission('CREATE') && (
              <Link to={ROUTES.CUSTOMER.CUSTOMER_SEGMENTATION.DETAIL.LINK + '?tabId=CREATE'}>
                <CustomButton type="primary" icon={<Plus className="!fill-white" />}>
                  {t('btn.create')}
                </CustomButton>
              </Link>
            )}
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <CustomProTable<CustomerSegmentModel>
            bordered
            columns={columns}
            dataSource={dataTable}
            handleResize={() => { }}
            actionRef={tableRef}
            request={async (params = {}, sort, filter) => {
              const data = await getDataTable({
                ...dataPaging,
                paging: {
                  ...dataPaging.paging,
                  orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  orderByDesc:
                    Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                },
              });

              if (Object.values(sort).length) {
                setDataPaging({
                  ...dataPaging,
                  paging: {
                    ...dataPaging.paging,
                    orderBy:
                      Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                    orderByDesc:
                      Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  },
                });
              }
              return {
                data: data,
                success: customerSegmentStore.listCustomerSegment.isSuccess,
              };
            }}
            rowKey="stt"
            pagination={{
              ...tablePagination(dataPaging, setDataPaging),
              total: customerSegmentStore.listCustomerSegment.paging?.totalCount,
            }}

            toolBarRender={() => [
              checkPermission('EXPORT') && (
                <CustomButton
                  loading={reportState.loading}
                  onClick={async () => {
                    setReportState({ loading: true });
                    const { paging, ...rest } = dataPaging
                    await customerSegmentPresenter.exportReport({ ...rest, companyCode: getPlantCode() });
                    setReportState({ loading: false });
                  }}
                  icon={<Icon.Download className={'!fill-dark'} />}
                >
                  {t('btn.export')}
                </CustomButton>
              )
            ]}

            options={{
              reload: true,
              density: false,
              search: false
            }}
          />
        </BoxContainer>

        {/* Form search */}
        <SearchBox
          onClose={onClose}
          className="lg:!w-[50%]"
          open={open.openDrawer}
          footer={
            <CustomButton
              htmlType="submit"
              className="my-auto ml-auto"
              type="primary"
              loading={loading.loadingSearch}
              onClick={() => {
                const code = form.getFieldValue('customerSegmentationCode');
                const dateFromTo = form.getFieldValue('ngayTao');

                setDataPaging({
                  ...form.getFieldsValue(),
                  // customerSegmentationCode: Number(code) ? Number(code) : undefined,
                  fromTime: dateFromTo && dateFromTo[0] ? dayjs(dateFromTo[0])?.format(DATE_FORMAT_POST) : undefined,
                  toTime: dateFromTo && dateFromTo[1] ? dayjs(dateFromTo[1])?.format(DATE_FORMAT_POST) : undefined,
                  paging: { ...dataPaging.paging, pageIndex: 1 },
                });
                form.submit();
                onClose();
              }}
            >
              {t('btn.search')}
            </CustomButton>
          }
        >
          <SearchForm
            form={form}
            onFinish={(value) => {
              tableRef.current?.reload();
            }}
            column="col-1"
            initialValues={{
              active: true,
              company: getPlantCode()
            }}
          >
            {/* Công ty */}
            <SearchItem name={'company'} label={t('search-form.company')}>
              <CustomSelect
                options={listSaleOrg}
                allowClear
                showSearch
                fieldNames={{ label: "value", value: "key" }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </SearchItem>
            {/* Người tạo */}
            <SearchItem name={'createBy'} label={t('search-form.created-by')}>
              <CustomSelect
                options={listCreateBy}
                fieldNames={{ label: 'value', value: 'key' }}
                filterOption={false}
                onSearch={(value) => {
                  searchCreateBy(value);
                }}
                allowClear
                showSearch
              />
            </SearchItem>
            {/* Mã phân khúc */}
            <SearchItem name={'customerSegmentationCode'} label={t('segment.ma-pk')}>
              <Input />
            </SearchItem>
            {/* Tên phân khúc */}
            <SearchItem name={'customerSegmentationName'} label={t('segment.ten-pk')}>
              <Input />
            </SearchItem>
            {/* Mốc thời gian tạo */}
            <SearchItem name={"commonDate"} label={"Mốc thời gian tạo"} start col2>
              <CustomSelect
                options={listCommonDate}
                fieldNames={{ label: "value", value: "key" }}
                onChange={async (value, option) => {
                  if (option) {
                    setDisableRangePicker(
                      option.key === "Custom" ? false : true
                    );
                    await getDateByKey(option.key);
                  } else {
                    setDisableRangePicker(false);
                    form.setFieldValue("ngayTao", undefined);
                  }
                }}
                allowClear
              />
            </SearchItem>
            {/* chọn ngày*/}
            <SearchItem name={"ngayTao"} col2>
              <RangePicker
                disabled={disableRangePicker}
                format="DD/MM/YYYY"
                className="w-full"
              />
            </SearchItem>
            {/* Trạng thái hoạt động */}
            <SearchItem name={'active'} label={'Trạng thái hoạt động'}>
              <CustomSelect options={dropdownstatus} allowClear />
            </SearchItem>
          </SearchForm>
        </SearchBox>
      </PageWrapper>
    );
  });
};

export default createCustomerSegmentation;
